import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';

import StatusMessage from '../../util/StatusMessage'
import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Select } from 'rmwc/Select';

class AdminHallTicketUpdate extends Component {

  constructor(props){
    super(props);
    this.state={
      data: {
        candidateName: '',
        email: '',
        mobile: '',
        testCities: [],
        testCityId: '',
        testCenterName: '',
        testCenterCountryId: '',
        tpoTestTrackList: [],
        tpoTestTrackId: '',
        tpoTestTrackName: '',
        testTimeSlot: '',
        duration:'',
        reportingTime: '',
        rollNumber: '',
        pinValue: '',
        testCenter: '',
        testCenterAddress: '',
        pinCode: '',
        landMark: '',
      },
      errorMsg: '',
    }
    this.handleTestCenterChange = this.handleTestCenterChange.bind(this);
  }

  componentDidMount() {
    let hallTicketId = this.props.match.params.hallticketId
    let userId = this.props.match.params.userId
    let data = Object.assign({}, this.state.data)

    return api.getHallTicketUpdateDetails(this.props.user.accessToken,hallTicketId,userId)
    .then((result) => {
      if (result.status === 'success') {
        data.candidateName = result.data.name
        data.email = result.data.email
        data.mobile = result.data.mobile
        data.testCityId = result.data.test_center_id
        data.testCenterCountryId = result.data.country_id
        data.tpoTestTrackId = result.data.tpo_test_track_id
        data.testTimeSlot = result.data.test_time_slot
        data.duration = result.data.duration
        data.reportingTime = result.data.reporting_time
        data.rollNumber = result.data.roll_number
        data.pinValue = result.data.pin_value
        data.testCenter = result.data.test_location
        data.testCenterAddress = result.data.test_location_address
        data.pinCode = result.data.pincode
        data.landMark = result.data.landmark
      }
        return api.getTestCenters(this.props.user.accessToken)
    }).then((result) => {
        data.testCities = result
        return api.getTPOTestTracks('', data.testCenterCountryId)
    }).then((tpoTestTrack) => {
        data.tpoTestTrackList = tpoTestTrack
        this.setState({data: data})
    })
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handleTestCenterChange(event){
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
      if(event.target.value){
        let selectedOption = event.target.value
        var index = event.target.selectedIndex;
        var optionElement = event.target.childNodes[index]
        
        //console.log(selectedOption)
        data.testCityId = selectedOption
        data.testCenterName = optionElement.getAttribute('data-name')
        this.setState({data: data})
      }
  }

  handleTestTrackChange = (event) => {
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      data.tpoTestTrackId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.tpoTestTrackName = optionElement.getAttribute('data-name')
    }
    this.setState({data: data})
  }

  handleUpdateHallTicket = (e, hallTicketId, userId) => {
    let data = Object.assign({}, this.state.data)

    let apiInput = {
      'hallticket_id': hallTicketId,
      'user_id': userId,
      'cand_name': this.state.data.candidateName,
      'email': this.state.data.email,
      'mobile': this.state.data.mobile,
      'test_center_id': this.state.data.testCityId,
      'test_track_id': this.state.data.tpoTestTrackId,
      'time_slot': this.state.data.testTimeSlot,
      'rollnumber': this.state.data.rollNumber,
      'test_location': this.state.data.testCenter,
      'location_address': this.state.data.testCenterAddress,
      'landmark': this.state.data.landMark,
      'pincode': this.state.data.pinCode,
      'pin_value': this.state.data.pinValue,
      'duration': this.state.data.duration,
      'reporting_time': this.state.data.reportingTime
    }

    api.updateHallTicket(this.props.user.accessToken,apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          this.setState({ errorMsg: 'Updated the Hall Ticket' })
        }
        else{
          this.setState({ errorMsg: result.data })
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
  }

  render() {
    let hallTicketId = this.props.match.params.hallticketId
    let userId = this.props.match.params.userId
    let handleUpdateHallTicket = this.handleUpdateHallTicket
    return(
      <Grid>
        <GridCell span="12">
          <Typography use="subtitle">Update Hall Ticket</Typography>
        </GridCell>
        <br/>
        <GridCell span="12">
          <Grid>
            <GridCell span="6">
              <TextField fullwidth label="Name" autoComplete="off" name="candidateName" onChange={this.onInputChange} value={this.state.data.candidateName} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="3">
              <TextField fullwidth label="email" autoComplete="off" name="email" onChange={this.onInputChange} value={this.state.data.email} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="3">
              <TextField fullwidth label="Mobile Number" autoComplete="off" name="mobile" onChange={this.onInputChange} value={this.state.data.mobile} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="6">
              <Select
                    name="testCity"
                    onChange={this.handleTestCenterChange}
                    value={this.state.data.testCityId}
                    className="two-col-input"
                    placeholder="--- Select Test City ---"
                  >
                    {this.state.data.testCities.map(testcenter => (
                      <option key={testcenter.id} value={testcenter.id} data-name={testcenter.name}
                        date-countryid = {testcenter.country_id}>
                        {testcenter.name}
                      </option>
                    ))}
              </Select>
            </GridCell>
            <GridCell span="6">
              <Select
                name="testTrackPrimary"
                onChange={this.handleTestTrackChange}
                value={this.state.data.tpoTestTrackId}
                className="two-col-input"
                placeholder="--- Select TPO Test Track ---"
              >
                {this.state.data.tpoTestTrackList.map(trackPrimary => (
                  <option key={trackPrimary.id} value={trackPrimary.id} data-name={trackPrimary.name}>
                    {trackPrimary.name}
                  </option>
                ))}
              </Select>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Test Time Slot" autoComplete="off" name="testTimeSlot" onChange={this.onInputChange} value={this.state.data.testTimeSlot} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Time Duration" autoComplete="off" name="duration" onChange={this.onInputChange} value={this.state.data.duration} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Reporting Time" autoComplete="off" name="reportingTime" onChange={this.onInputChange} value={this.state.data.reportingTime} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Roll Number" autoComplete="off" name="rollNumber" onChange={this.onInputChange} value={this.state.data.rollNumber} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Pin" autoComplete="off" name="pinValue" onChange={this.onInputChange} value={this.state.data.pinValue} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Test Center" autoComplete="off" name="testCenter" onChange={this.onInputChange} value={this.state.data.testCenter} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Test Center Address" autoComplete="off" name="testCenterAddress" onChange={this.onInputChange} value={this.state.data.testCenterAddress} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Pin Code" autoComplete="off" name="pinCode" onChange={this.onInputChange} value={this.state.data.pinCode} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4">
              <TextField fullwidth label="Land Mark" autoComplete="off" name="landMark" onChange={this.onInputChange} value={this.state.data.landMark} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="4"></GridCell>
            <GridCell span="4">
              <Button raised onClick={((e) => handleUpdateHallTicket(e, hallTicketId, userId))}>UPDATE</Button>
            </GridCell>
            <GridCell span="4"></GridCell>
          </Grid>
        </GridCell>
        <GridCell span="12">
          <StatusMessage error_msg = {this.state.errorMsg}/>
        </GridCell>
      </Grid>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHallTicketUpdate);


// WEBPACK FOOTER //
// ./src/views/admin/AdminHallTicketUpdate.jsx